import { Injectable } from '@angular/core';
import {BaseService} from "./base.service";
import {HttpClient} from "@angular/common/http";
import {AlertService} from "./alert.service";
import {GlobalService} from "./global.service";
import {UploadService} from "./upload.service";
import {Observable} from "rxjs";
import {AppUrl} from "../constants/app-url";

@Injectable({
  providedIn: 'root'
})
export class EventService  extends BaseService {

  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService,
              private fileUploadService: UploadService) {
    super(http, alertService, globalService);
  }
  get(data): Observable<any> {
    return this.getRequest(AppUrl.EVENTS(), data);
  }
  detail(id): Observable<any> {
    return this.getRequest(AppUrl.EVENTS(id));
  }

  create(data): Observable<any> {
    return this.postRequest(AppUrl.EVENTS(), data);
  }

  update(id, data): Observable<any> {
    return this.putRequest(AppUrl.EVENTS(id), data);
  }

  update_content(id, data): Observable<any> {
    return this.putRequest(AppUrl.EVENT_CONTENT(id), data);
  }

  updateStatus(id, data): Observable<any> {
    return this.putRequest(AppUrl.EVENT_STATUS(id), data);
  }
  delete(id): Observable<any> {
    return this.deleteRequest(AppUrl.EVENTS(id));
  }
  fileUpload(params, event): Observable<any> {
    return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD(), params, event);
  }

  fileUploadAdmin(params, event): Observable<any> {
    return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD_ADMIN(), params, event);
  }
}
